import React from 'react';
import type { Thing, WithContext } from 'schema-dts';

type NonStringThing = Exclude<Thing, string>;

const StructuredData = ({ data }: { data: NonStringThing }) => {
  const structuredData: WithContext<Thing> = {
    '@context': 'https://schema.org',
    ...data,
  };
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
};

export default StructuredData;
